import { render, staticRenderFns } from "./bindStatus.vue?vue&type=template&id=226952ed&scoped=true"
import script from "./bindStatus.vue?vue&type=script&lang=js"
export * from "./bindStatus.vue?vue&type=script&lang=js"
import style0 from "./bindStatus.vue?vue&type=style&index=0&id=226952ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226952ed",
  null
  
)

export default component.exports